export const API_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;
export const API_KEY = `${process.env.REACT_APP_ORG_INFO_API_KEY}`;
export const getUsersUrl = (string: string) => `/admin${string}`;
